export default __webpack_public_path__ + "static/media/4.73c449a4.jpeg";